'use client';

import React, { useContext } from 'react';

import { useSearchParams } from 'next/navigation';

import { YouMightAlsoLikeVariant } from '../YouMightAlsoLikeVariant';

import { RefererContext } from '@/modules/activityTracker/RefererProvider';
import { VARIANT_IDENTIFIER } from '@/modules/experiments/config';
import { useExperiments } from '@/modules/experiments/useExperiments';
import { isExternalPLALander } from '@/modules/product/helpers/isExternalPLALander';

type ModulesVariantDeciderProps = {
  originalModules: React.ReactNode;
};

export function ModulesVariantDecider({
  originalModules,
}: ModulesVariantDeciderProps) {
  const referer = useContext(RefererContext);
  const searchParams = useSearchParams();
  const [{ web_9227_filterable_ymal_internal_landers }] = useExperiments(
    ['web_9227_filterable_ymal_internal_landers'],
    { deferred: true }
  );

  // Check if THIS page load came from external source (PLA or organic)
  // Include URL search params to detect gclid, ~channel, etc.
  const isExternalReferer = isExternalPLALander({
    referer,
    params: searchParams,
  });

  if (
    !isExternalReferer &&
    web_9227_filterable_ymal_internal_landers === VARIANT_IDENTIFIER
  ) {
    return <YouMightAlsoLikeVariant sixProductsPerRow />;
  }

  return <>{originalModules}</>;
}
